import { VortexUICurrentAttempt } from "../components/ui/hud/VortexUI";
import { DaarcBaseScenario } from "../scenarios/DaarcBaseScenario";
import { constants } from "./constants";
import { globals } from "./globals";
import { ScenariosConfig } from "./interfaces";
export enum Windows {
	Nothing = 0,
	MainMenu = 1,
	DamonJones = 2,
	NathanielClarke = 3,
	JavierMcBride = 4,
	AndreGarza = 5,
	GuadalupeHerrera = 6,
	DarnellKennedy = 7,
	FaithAlvarado = 8,
	EmanuelMcKenzie = 9,
	RuthMcKenzie = 10,
	LeroyRobinson = 11,
	WilliamHoward = 12,
	AngelaScott = 13,
	
}

export const mapDivEnterToClick = (keyUpEvt: any) => {
    if(keyUpEvt.key === 'Enter') {
        $(keyUpEvt.target as any).trigger('click');
    }
}


var bvmAttempts = 0;
export const registerBvmAttempt = (scenario: DaarcBaseScenario) => {
    if(globals.vortexAttempts.indexOf(VortexUICurrentAttempt.BVM) === -1) {
        globals.vortexAttempts.push(VortexUICurrentAttempt.BVM);
    }
    scenario.vortexId = scenario.uiWrapper.displayVortexUI({
        currentAttempt: VortexUICurrentAttempt.BVM,
        bvmAttemps: ++bvmAttempts,
        steps: globals.vortexAttempts
    }, scenario.vortexId);
}

var ettAttempts = 0;
export const registerEttAttempt = (scenario: DaarcBaseScenario) => {
    if(globals.vortexAttempts.indexOf(VortexUICurrentAttempt.ETT) === -1) {
        globals.vortexAttempts.push(VortexUICurrentAttempt.ETT);
    }
    scenario.vortexId = scenario.uiWrapper.displayVortexUI({
        currentAttempt: VortexUICurrentAttempt.ETT,
        ettAttemps: ++ettAttempts,
        steps: globals.vortexAttempts
    }, scenario.vortexId);
}

var sgaAttempts = 0;
export const registerSgaAttempt = (scenario: DaarcBaseScenario) => {
    if(globals.vortexAttempts.indexOf(VortexUICurrentAttempt.SGA) === -1) {
        globals.vortexAttempts.push(VortexUICurrentAttempt.SGA);
    }
    scenario.vortexId = scenario.uiWrapper.displayVortexUI({
        currentAttempt: VortexUICurrentAttempt.SGA,
        sgaAttemps: ++sgaAttempts,
        steps: globals.vortexAttempts
    }, scenario.vortexId);
}

var partId = 0;
export const getNextPartId = () => {
    return 'Scenario Part ' + (partId++).toString();
}

export const forceRerenderUI = (uiName: string, instanceName?: string) => {
    if(!(window as any)[uiName]) {
        return undefined;
    }
    
    if(instanceName) {
        if(!(window as any)[uiName][instanceName]) {
            return undefined;
        }
        return (window as any)[uiName][instanceName]();
    }

    if(!(window as any)[uiName]['main']) {
        return undefined;
    }
    return (window as any)[uiName]['main']();
}

export const reactToSmeDebug = (componentName: string, callback: () => void) => {
    var evts = (window as any)[constants.smeDebug.globalEvents.smeDebugUpdate];
    evts[componentName] = callback;
}

export const getWindowVariable = (key: string) => {
    return (window as any)[key];
}

export const getSaveData = (): ScenariosConfig => {
    var savedData: any = localStorage.getItem('saved-game-daarc');
    if(savedData) {
        savedData = JSON.parse(savedData);
    } else {
        var newData: ScenariosConfig = {
            failedSummativeCount: 0,
            completedAllPracticeScenarios: false,
            completedAllTestScenarios: false,
            selectedSummativeScenarioIndices: null,
            scenarios: [
                {
                    scenarioName: 'Level 1',
                    isUnlocked: true,
                    isSummative: false,
			        isCompleted: false,
                    patientName: 'Damon Jones',
                    isMale: true,
                    scenarioWindow: Windows.DamonJones,
                    score: 0
                },
                {
                    scenarioName: 'Level 4',
                    isUnlocked: false,
                    isSummative: false,
			        isCompleted: false,
                    patientName: 'Javier McBride',
                    isMale: true,
                    scenarioWindow: Windows.JavierMcBride,
                    score: 0
                },
                {
                    scenarioName: 'Level 12',
                    isUnlocked: false,
                    isSummative: false,
			        isCompleted: false,
                    patientName: 'Angela Scott',
                    isMale: false,
                    scenarioWindow: Windows.AngelaScott,
                    score: 0
                },
                {
                    scenarioName: 'Level 2',
                    isUnlocked: false,
                    isSummative: false,
			        isCompleted: false,
                    patientName: 'Nathaniel Clarke',
                    isMale: true,
                    scenarioWindow: Windows.NathanielClarke,
                    score: 0
                },
                {
                    scenarioName: 'Level 3',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Andre Garza',
                    isMale: true,
                    scenarioWindow: Windows.AndreGarza,
                    score: 0
                },
                {
                    scenarioName: 'Level 5',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Guadalupe Herrera',
                    isMale: false,
                    scenarioWindow: Windows.GuadalupeHerrera,
                    score: 0
                },
                {
                    scenarioName: 'Level 6',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Darnell Kennedy',
                    isMale: true,
                    scenarioWindow: Windows.DarnellKennedy,
                    score: 0
                },
                {
                    scenarioName: 'Level 7',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Faith Alvarado',
                    isMale: false,
                    scenarioWindow: Windows.FaithAlvarado,
                    score: 0
                },
                {
                    scenarioName: 'Level 8',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Emanuel McKenzie',
                    isMale: true,
                    scenarioWindow: Windows.EmanuelMcKenzie,
                    score: 0
                },
                {
                    scenarioName: 'Level 9',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Ruth McKenzie',
                    isMale: false,
                    scenarioWindow: Windows.RuthMcKenzie,
                    score: 0
                },
                {
                    scenarioName: 'Level 10',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'Leroy Robinson',
                    isMale: true,
                    scenarioWindow: Windows.LeroyRobinson,
                    score: 0
                },
                {
                    scenarioName: 'Level 11',
                    isUnlocked: false,
                    isSummative: true,
                    isCompleted: false,
                    patientName: 'William Howard',
                    isMale: true,
                    scenarioWindow: Windows.WilliamHoward,
                    score: 0
                }
            ]
        };
        savedData = newData;
    }

    return savedData;
}

export const setFocus = (id: string, onDone?: (success: boolean) => void) => {
    setTimeout(() => {
        const el = document.getElementById(id);

        if(el) {
            document.getElementById(id).focus();
            if(onDone) {
                onDone(true);
            }
        } else {
            if(onDone) {
                onDone(false);
            }
        }
    }, 250);
}

export const saveGame = (data: ScenariosConfig): void => {
    localStorage.setItem('saved-game-daarc', JSON.stringify(data));
}

export const setUp508 = (onGetCurrent508WindowLayer: () => {objects: string[]}) => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.which === 9) {
            var current508Layer = onGetCurrent508WindowLayer();

            if(current508Layer.objects.length !== 2) {
                return;
            }

            var lastObj = current508Layer.objects[current508Layer.objects.length - 1]
    
            //508 Window Constraint
            if (e.shiftKey) {
                if (document.activeElement.id === current508Layer.objects[0]) {
                    setFocus(lastObj);
                    e.preventDefault();
                }
            } else {
                if (document.activeElement.id === lastObj) {
                    setFocus(current508Layer.objects[0]);
                    e.preventDefault();
                }
            }
        }
    });
}